export default String.raw`
{% comment -%}
    Rekurencyjne znajdowanie produktu, stanu magazynowego oraz kluczy w drzewie wariantów
    @param currentSupply - aktualny wariant do przeszukania
    @param depth - obecna głębokość (do ograniczenia rekurencji)
    @param maxDepth - maksymalna głębokość rekurencji
    @return foundProduct - znaleziony produkt (jeśli towar z cechami, to rodzic)
    @return dataKeys - klucze znalezionego wariantu
    @return supplyStockLevel - poziom zapasów znalezionego wariantu
{% endcomment -%}

{% assign foundProduct = null -%}
{% assign dataKeys = currentSupply.Key -%}
{% assign supplyStockLevel = currentSupply.StockLevel -%}

{% comment -%}<!-- Sprawdź, czy obecny wariant ma produkt -->{% endcomment -%}
{% if currentSupply.Product -%}
    {% assign foundProduct = currentSupply.Product -%}
    {% assign dataKeys = currentSupply.Key -%}
    {% assign supplyStockLevel = currentSupply.StockLevel -%}
{% elsif depth < maxDepth and currentSupply.Supplies and currentSupply.Supplies[0] -%}
    {% comment -%}<!-- Sprawdź podwarianty rekurencyjnie -->{% endcomment -%}
    {% for childSupply in currentSupply.Supplies -%}
        {% if foundProduct == null -%}
            {% assign nextDepth = depth | Plus: 1 -%}
            {% include 'partials/product/find-variant-product.html' with currentSupply: childSupply, depth: nextDepth, maxDepth: maxDepth -%}
        {% endif -%}
    {% endfor -%}
{% elseif foundProduct == null and currentSupply.Supplies == empty -%}
{% comment -%}<!-- Jeśli nie znaleziono produktu i brak podwariantów (towar z cechami) - przypisujemy rodzica -->{% endcomment -%}
    {% assign foundProduct = product -%}
{% endif -%}
`